import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateAdminRoleResultModal} from './update-admin-role.result.modal';
import {
    clearResult,
    selectUpdateAdminRoleShown,
    selectUpdateAdminRoleTask,
    selectUpdateAdminRoleUuid,
} from './update-admin-role.slice';


export const UpdateAdminRoleResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateAdminRoleUuid}
        actionTaskSelector={selectUpdateAdminRoleTask}
        actionShownSelector={selectUpdateAdminRoleShown}
        clearResult={clearResult}>
        {({id, onClose}) => <UpdateAdminRoleResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
